//===================================================
// 1.Load,Init,Settings
//===================================================
import React, { useState, useEffect } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
import countries from "world-countries";

// Material-ui
import { Container, Typography } from "@mui/material";

// custom components

// css *required
import { useStyles } from "./index.css";

//===================================================
// 2.Main Component
//===================================================
const CustomPhoneField = (props) => {
  // 2-1. useStyles *require
  const classes = useStyles();

  // 2-2. Store
  const { loginUserPhone, selectedCountry, setPhoneNumber } = props;
  
  // Convert cca3 to cca2 (lowercase) for react-phone-input-2
  const getCountryCode = (country) => {
    if (!country) return "au"; // Default to Australia

    // If it's already cca2, just lowercase it
    if (country.length === 2) {
      return country.toLowerCase();
    }

    // If it's cca3, convert to cca2
    const countryObj = countries.find((c) => c.cca3 === country);
    return countryObj ? countryObj.cca2.toLowerCase() : "au";
  };

  const [phoneValue, setPhoneValue] = useState(loginUserPhone ?? "");
  const [countryCode, setCountryCode] = useState(getCountryCode(selectedCountry));
  const [lastCountry, setLastCountry] = useState(selectedCountry);

  // Update country code when selectedCountry changes
  useEffect(() => {
    if (selectedCountry !== lastCountry) {
      const newCountryCode = getCountryCode(selectedCountry);
      setCountryCode(newCountryCode);
      setLastCountry(selectedCountry);
      
      // Reset phone value when country changes
      setPhoneValue("");
      if (setPhoneNumber) {
        setPhoneNumber("");
      }
    }
  }, [selectedCountry, lastCountry, setPhoneNumber]);

  // showMain
  return showMain({
    ...props,
    classes,
    phoneValue,
    setPhoneValue,
    countryCode,
  });
};

//===================================================
// 3.Export
//===================================================
export default CustomPhoneField;

//===================================================
// 4.propTypes and defaultProps
//===================================================

//4-1. propTypes
CustomPhoneField.propTypes = {};

//4-2. defaultProps
CustomPhoneField.defaultProps = {};

//===================================================
// 5.Functions *require showMain()
//===================================================
/**
 * Show main
 * @param {*} props
 */
const showMain = (props) => {
  const {
    classes,
    hasError,
    disabled,
    countryCode,
    selectedCountry,
    phoneValue,
  } = props;
  return (
    <React.Fragment>
      <Container align="left" className={classes.container} maxWidth={false}>
        <PhoneInput
          key={countryCode}
          className={hasError ? classes.hasError : ""}
          country={countryCode}
          onlyCountries={countryCode ? [countryCode] : undefined}
          preferredCountries={countryCode ? [countryCode] : undefined}
          countryCodeEditable={false}
          disableDropdown={selectedCountry ? true : false}
          value={phoneValue}
          onChange={(e) => handleSetPhoneNumber(e, props)}
          inputProps={{
            name: "phone",
            required: true,
            readOnly: disabled,
          }}
          disabled={!selectedCountry}
        />
        {hasError ? (
          <Container align="left">
            <Typography variant="caption" color="#d32f2f" gutterBottom>
              {hasError}
            </Typography>
          </Container>
        ) : null}
      </Container>
    </React.Fragment>
  );
};

//===================================================
// 6.Actions
//===================================================

const handleSetPhoneNumber = (value, props) => {
  const { setPhoneValue, setPhoneNumber } = props;
  setPhoneValue(value);
  setPhoneNumber(`+${value}`);
};
